// src/validators.js
import {isArray} from 'lodash';
import moment from 'moment';
import {isDecimal, isEmail, isNumeric, isURL} from 'validator';
import {isValidDuration, isValidDate} from './date';

const imageUrlJpgRegex = /\.jpe?g$/i;
const priceRegex = /[\d]+\.[\d]{2}/;

const decimal = (value) => (value && !isDecimal(String(value)) ? 'This is not a valid decimal number' : undefined);

const duration = (value) => (value && !isValidDuration(String(value)) ? 'This duration is invalid (examples: 1h 4m 23s, 23m 42s)' : undefined);

const date = (value) => (value && !isValidDate(String(value)) ? 'This date is invalid' : undefined);

const email = (value) => (value && !isEmail(String(value)) ? 'This email address is invalid' : undefined);

const rating = (value) => (![
        'G',
        'NC17',
        'Not Rated',
        'NR',
        'NR/AO',
        'PG',
        'PG13',
        'R',
        'TV14',
        'TVG',
        'TVMA',
        'TVPG',
        'TVY',
        'TVY7',
        'X',
    ].includes(value)
        ? 'A valid rating must be chosen.'
        : undefined);

const nonNegativeNumber = (value) => (value && +value < 0 ? 'Non-negative number required' : undefined);

const numeric = (value) => (value && !isNumeric(String(value)) ? 'This is not a valid integer number' : undefined);

const number = (value) => (value && !isNumeric(String(value), {no_symbols: true}) ? 'This is not a valid number' : undefined);

const price = (value) => (value && (!isDecimal(String(value)) || !priceRegex.test(String(value)))
        ? 'Price must match format 1.23'
        : undefined);

const required = (value) => (!value || (isArray(value) && !value.length) || value === '' ? 'This field cannot be empty' : undefined);

const network = (value) =>
    (!value || (isArray(value) && !value.length) || value === '' ? 'Choose a Network' : undefined);

const url = (value) => (value && !isURL(String(value)) ? 'This URL is invalid' : undefined);

const imageUrlJpg = (value) => (value && (!isURL(String(value)) || !imageUrlJpgRegex.test(String(value)))
        ? 'This image URL is invalid or not a JPEG'
        : undefined);

const releaseYear = (value) => {
    const endYear = +moment().format('YYYY') + 100;
    const year = +value;

    return value && (year < 1890 || year > endYear) ? `This must be a year between 1890 and ${endYear}` : undefined;
};

const role = (value) => (!/^[\w0-9_]*$/.test(value) ? 'Only special character allowed is underscore(_).' : undefined);

const username = (value) => {
    const message = [];

    if (!value || value.length < 4) {
        message.push('Must be at least 4 characters.');
    }

    if (value.length > 31) {
        message.push('Must be less than 32 characters.');
    }

    if (/[A-Z]/.test(value)) {
        message.push('Must be all lowercase.');
    }

    if (!/^[\w0-9._-]*$/.test(value)) {
        message.push('Only special characters allowed are underscore(_), dash(-) and dot(.).');
    }

    return message.length ? message.join(' ') : undefined;
};

const password = (value) => (!value || value.length < 8 ? 'Password must be at least 8 characters' : undefined);

const text = (value) => (value.length > 255 ? 'Must be less than 256 characters.' : undefined);

const callSign = (value) => (value.length > 4 ? 'Must be less than 5 characters.' : undefined);

export default {
    callSign,
    date,
    decimal,
    duration,
    email,
    imageUrlJpg,
    imageUrlJpgRegex,
    network,
    nonNegativeNumber,
    number,
    numeric,
    password,
    price,
    priceRegex,
    rating,
    releaseYear,
    required,
    role,
    text,
    url,
    username,
};
